import { JsonLd } from "@/lib/seo";
import { useLang } from "@/lib/i18n";

export const CONTACTS = [
  { name: "Ibrahim Khalaf", phone: "070-791 29 01", tel: "+46707912901", testid: "ibrahim" },
  { name: "Sani Jawanmeri", phone: "073-970 87 96", tel: "+46739708796", testid: "sani" },
];

export default function SeoSchema({ packages = [], faq = [] }) {
  const { lang } = useLang();
  const origin = typeof window !== "undefined" ? window.location.origin : "https://nivadigital.se";
  const business = {
    "@context": "https://schema.org",
    "@type": ["ProfessionalService", "LocalBusiness"],
    "@id": `${origin}/#business`,
    name: "Nivå Digital",
    alternateName: ["Niva Digital", "Nivådigital", "Nivadigital", "Nivådigitals", "Nivadigitals", "Nivå"],
    url: origin,
    logo: `${origin}/logo512.png`,
    image: `${origin}/og-image.png`,
    description:
      lang === "en"
        ? "Digital agency in Stockholm building affordable, professional websites, logos, advertising and Google visibility for Swedish small businesses."
        : "Digital byrå i Stockholm som bygger prisvärda, professionella hemsidor, logotyper, reklam och Google-synlighet för svenska småföretag.",
    slogan: "Ta ditt företag till nästa nivå.",
    email: "nivadigitals@gmail.com",
    telephone: CONTACTS.map((c) => c.tel),
    priceRange: "4 990 kr – 17 990 kr",
    currenciesAccepted: "SEK",
    areaServed: { "@type": "Country", name: "Sverige" },
    address: { "@type": "PostalAddress", addressLocality: "Stockholm", addressCountry: "SE" },
    founder: CONTACTS.map((c) => ({ "@type": "Person", name: c.name, telephone: c.tel })),
    knowsAbout: ["Hemsidor", "Webbdesign", "Branding", "Logotyp", "Reklam", "SEO", "Google Business", "Sociala medier"],
    makesOffer: packages.map((p) => ({
      "@type": "Offer",
      name: `${p.name} – ${lang === "en" ? "website & brand package" : "hemsida & varumärkespaket"}`,
      price: (p.price || "").replace(/[^\d]/g, ""),
      priceCurrency: "SEK",
      description: p.subtitle,
    })),
  };
  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${origin}/#website`,
    url: origin,
    name: "Nivå Digital",
    alternateName: ["Niva Digital", "Nivådigital", "Nivadigitals"],
    inLanguage: ["sv-SE", "en-GB"],
    publisher: { "@id": `${origin}/#business` },
  };
  const faqPage = faq.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faq.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }
    : null;
  return (
    <>
      <JsonLd data={business} />
      <JsonLd data={website} />
      {faqPage && <JsonLd data={faqPage} />}
    </>
  );
}
